import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Article, Topic } from "../typeDefs/news";
import { QueueMessage } from "../typeDefs/queueManagement";

export interface NewsState {
    topics: Topic[];
    articles: Article[];
    loading: boolean;
    logs: QueueMessage[];
    mostRecentRun: Date | null;
}

const initialState: NewsState = {
    topics: [],
    articles: [],
    loading: false,
    logs: [],
    mostRecentRun: null,
};

export const newsSlice = createSlice({
    name: "news",
    initialState,
    reducers: {
        setTopics: (state, action: PayloadAction<Topic[]>) => {
            state.topics = action.payload;
        },
        setArticles: (state, action: PayloadAction<Article[]>) => {
            state.articles = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setMessages: (state, action: PayloadAction<QueueMessage[]>) => {
            state.logs = action.payload;
        },
        setMostRecentRun: (state, action: PayloadAction<Date | null>) => {
            state.mostRecentRun = action.payload;
        },
    },
});

export const {
    setTopics,
    setArticles,
    setLoading,
    setMessages,
    setMostRecentRun,
} = newsSlice.actions;

export default newsSlice.reducer;
